import React, { useState, useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Box, Container, Paper, Typography, TextField, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import globalContext from '../../context/context';

const PasswordResetFinishPage = () => {
  const { t } = useTranslation();
  const { resetPasswordFinish } = useContext(globalContext);

  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!newPassword || !confirmPassword) {
      setError('Both fields are required.');
      return;
    }

    if (newPassword.length < 4 || newPassword.length > 50) {
      setError('Password must be between 4 and 50 characters.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    resetPasswordFinish(key, newPassword);
  };

  return (
    <Box sx={{ bgcolor: 'rgba(0,0,0, .2)', minHeight: '100vh', py: 4 }}>
      <Container sx={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex' }}>
        <Paper sx={{ width: { xs: '95%', md: '60%' }, p: 3, bgcolor: '#fff' }}>
          <Typography variant="h4" component="h1" sx={{ textAlign: 'center', pb: 3 }}>
            Reset Password
          </Typography>
          {key ? (
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="New Password"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                margin="normal"
                required
              />
              <TextField
                fullWidth
                label="Confirm Password"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                margin="normal"
                required
              />
              {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {error}
                </Alert>
              )}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
              >
                Reset Password
              </Button>
            </form>
          ) : (
            <Alert severity="error">
              Invalid reset link.
            </Alert>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default PasswordResetFinishPage;